exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".workshop-pagination .container{padding-top:20px;padding-bottom:20px}.workshop-pagination .container .pagination{font-size:20px;text-align:center}.workshop-pagination .container .pagination span{margin-left:10px;border:1px solid #000;height:30px;width:30px;opacity:.54;color:#000;cursor:pointer;display:inline-block;line-height:30px;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.workshop-pagination .container .pagination span.active{color:#039ee5;border:1px solid #039ee5;opacity:1}.workshop-pagination .container .pagination span.active:hover{background-color:#039ee5;color:#fff}.workshop-pagination .container .pagination span:hover{opacity:.87}.workshop-pagination .container .pagination span:first-child{margin-left:10px}.workshop-pagination .container .pagination span:last-child{margin-right:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js?outputStyle=expanded!./src/styles/css/pagination.scss
// module id = 974
// module chunks = 0